/**
 * Foot-anchored isometric depth sort (per ENGN-02, CONTEXT.md).
 *
 * Sort key = (tileX + tileY) * 1000 + screenY.
 *
 * The 1000 multiplier guarantees that tile-row ordering dominates screenY
 * tiebreak up to 999 pixels per row — enough for the full Manhattan map.
 * Two NPCs crossing on the same tile row fall back to screenY (foot
 * position) so the one whose feet are lower on-screen renders in front.
 */
export function sortKey(tileX: number, tileY: number, screenY: number): number {
  return (tileX + tileY) * 1000 + screenY
}
